<template>
  <a-dropdown :trigger="['click']" placement="bottomLeft" v-if="hasPermission([consts. permissions.CREATE_ACADEMIC_MANAGEMENT, consts.permissions.UPDATE_ACADEMIC_MANAGEMENT, consts.permissions.CREATE_PAYROLL_SETTINGS]) || hasRole([consts.rolesText.CONTADOR])">
    <div :class="$style.dropdown">
      <i class="fe fe-database" :class="$style.icon"></i>
      <span class="d-none d-xl-inline">{{ $t('topBar.projectManagement') }}</span>
    </div>
    <a-menu slot="overlay">
      <a-sub-menu title="Gestión académica" v-if="hasModule('academicModule') && !hasRole([consts.rolesText.CONTADOR])">
        <a-menu-item>
          <router-link :to="'/settings/levels'">Niveles de escolaridad
          </router-link>
        </a-menu-item>
        <a-menu-item>
          <router-link :to="'/settings/qualification-range'">Rangos de calificación
          </router-link>
        </a-menu-item>
        <a-menu-item>
          <router-link :to="'/settings/grades'">Grados
          </router-link>
        </a-menu-item>
        <a-menu-item>
          <router-link :to="'/settings/groups'">Grupos
          </router-link>
        </a-menu-item>
        <a-menu-divider />
        <a-menu-item>
          <router-link :to="'/settings/areas'">Áreas académicas
          </router-link>
        </a-menu-item>
        <a-menu-item>
          <router-link :to="'/settings/subjects'">Asignaturas
          </router-link>
        </a-menu-item>
        <a-menu-item>
          <router-link :to="'/settings/electives'">Electivas
          </router-link>
        </a-menu-item>
        <a-menu-divider />
        <a-menu-item>
          <router-link :to="'/settings/years'">Años
          </router-link>
        </a-menu-item>
        <a-menu-item>
          <router-link :to="'/settings/periods'">Periodos
          </router-link>
        </a-menu-item>
        <a-menu-item>
          <router-link :to="'/settings/enrollments'">Matrículas
          </router-link>
        </a-menu-item>
      </a-sub-menu>
      <a-sub-menu title="Gestión de CMS" v-if="hasModule('academicModule') && !hasRole([consts.rolesText.CONTADOR])">
        <a-menu-item>
          <router-link :to="'/cms'">Gestionar posts
          </router-link>
        </a-menu-item>
      </a-sub-menu>
      <a-sub-menu title="Gestión de nómina" v-if="hasModule(['payrollModule'])">
        <a-menu-item>
          <router-link :to="'/payroll/settings'">Configuración
          </router-link>
        </a-menu-item>
      </a-sub-menu>
      <a-sub-menu title="Gestión contable" v-if="hasModule(['payrollModule'])">
        <a-menu-item>
          <router-link :to="'/accountant/puc'">Cuentas contables
          </router-link>
        </a-menu-item>
        <a-menu-item>
          <router-link :to="'/accountant/cost-center'">Centro de costo
          </router-link>
        </a-menu-item>
      </a-sub-menu>
      <a-menu-divider v-if="!hasRole([consts.rolesText.CONTADOR])" />
      <a-menu-item v-if="!hasRole([consts.rolesText.CONTADOR])">
        <router-link :to="'/settings/params'">Gestión de parámetros
        </router-link>
      </a-menu-item>
      <!-- <a-menu-item-group title="Inactive">
        <a-menu-item>
          <a href="javascript: void(0);">Marketing</a>
        </a-menu-item>
      </a-menu-item-group> -->
      <!-- <a-menu-divider />
      <a-menu-item>
        <a href="javascript: void(0);">
          <i class="fe fe-settings mr-2" />
          Settings
        </a>
      </a-menu-item> -->
    </a-menu>
  </a-dropdown>
</template>

<script>
import { mapState } from 'vuex'
import { consts, hasPermission, hasRole } from '@/services/utilities'
import store from 'store'

export default {
  data() {
    return {
      consts: consts,
    }
  },
  computed: {
    ...mapState(['user']),
  },
  methods: {
    hasPermission(permissions) {
      return hasPermission(permissions, this.user.permissions)
    },
    hasRole(roles) {
      return hasRole(roles, this.user.role)
    },
    hasModule(module) {
      const userStorage = JSON.parse(store.get('userData'))
      if (module === undefined) {
        return true
      }
      return userStorage.school[module] === true
    },
  },
}
</script>

<style lang="scss" module>
@import "./style.module.scss";
</style>
